export default function getGender (prefix) {
    switch (prefix) {
        case "L":
            return "Laki-laki";
        case "P":
            return "Perempuan";
        default:
            return "Tidak diketahui";
    }
}